import { NgTemplateOutlet } from "@angular/common";
import { ChangeDetectionStrategy, Component, contentChild, input, TemplateRef } from "@angular/core";

@Component({
  selector: "app-catalog-toolbar",
  imports: [NgTemplateOutlet],
  template: ` @if (display()) {
    <div
      animate.enter="enter-fade-up-scale"
      animate.leave="leave-fade-up-scale"
      class="absolute bottom-4 left-1/2 -translate-x-1/2 rounded-lg border border-gray-100 bg-gray-50 px-3.5 py-2 starting:open:opacity-0"
      style="box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px"
    >
      <ng-container [ngTemplateOutlet]="content()"></ng-container>
    </div>
  }`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CatalogToolbarComponent {
  readonly content = contentChild.required<TemplateRef<never>>(TemplateRef);
  readonly display = input<boolean>();
}
